import { Login, CallbackPage}  from "../features/login";
import { Machines } from "../features/machines";
import { Product } from "../features/product";
import Contents from "../features/contents";
//  import { Test } from "../features/test/Test";

export default [
  {
    path: "machines",
    element: Machines,
    isNavbar: true,
  },
  {
    path: "product",
    element: Product,
    isNavbar: true,
  },
  {
    path: "content",
    element: Contents,
    isNavbar: true,
  },
  {
    path: "login",
    element: Login,
    isNavbar: false,
  },
  {
    path: "callback",
    element: CallbackPage,
    isNavbar: false,
  },
  //  {
  //   path: "recipes",
  //   element: Recipes,
  //   isNavbar: true,
  //  },
  //  {
  //   path: "test",
  //   element: Test,
  //   isNavbar: true,
  //  },
];
